// extracted by mini-css-extract-plugin
export default {"gallery":"CardGalleryContainer_gallery__Nm+mG"};